import { useCourse } from 'presentation/hooks/courses';
import React from 'react';
import { ToroLearnIcon } from '../icon';

import './styles.scss';

interface IProps {
    setShowToroFormModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ToroLearnLockedPlayer = ({ setShowToroFormModal }: IProps): JSX.Element => {
    const { course } = useCourse();

    if (!course) return <span></span>;

    return (
        <a type="button" onClick={() => setShowToroFormModal(true)} className="btn d-block p-0">
            <div className="d-flex align-items-center justify-content-center">
                <div
                    className="lesson-player-locked"
                    style={{ backgroundImage: `url(${course.coverUrl})` }}
                ></div>
                <div className="lesson-player-locked-info">
                    <ToroLearnIcon icon="play-circle" size={72} fill="white" />
                    <p className="mt-4">Invista com a Toro para continuar</p>
                </div>
            </div>
        </a>

    );
};
